var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaugeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98.08 98.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;opacity:.1;}.cls-2{fill:#282828;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4,
    y: 4,
    width: 90.08,
    height: 90.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.08,8V90.08H8V8H90.08M98.08,0H0V98.08H98.08V0h0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 98.08,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 10.99,
    width: 98.08,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 21.98,
    width: 98.08,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 32.97,
    width: 98.08,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 43.01,
    width: 98.08,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 54,
    width: 98.08,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 64.99,
    width: 98.08,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 75.98,
    width: 98.08,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 87.2,
    width: 98.08,
    height: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeBg);
export default __webpack_public_path__ + "static/media/gauge-bg.26baa2fcc430b144ed3d78db9dd2baa7.svg";
export { ForwardRef as ReactComponent };